module.exports = __webpack_public_path__ + "static/media/award.8605c9cb.svg";